module.exports = __webpack_public_path__ + "assets/img/first_user.dbf7dc3e.png";